// extracted by mini-css-extract-plugin
module.exports = {"container":"FaqPage_container__10uua","page_title":"FaqPage_page_title__gNaTK"};